import type {UnitSystem} from '@gaia/types';

import isOSMUnnamed from './isOSMUnnamed';

function capitalize(s: string) {
    return s.charAt(0).toLocaleUpperCase() + s.slice(1);
}

export default function getOSMFeatureName(
    properties: GeoJSON.GeoJsonProperties | null,
    unitSystem?: UnitSystem
) {
    const isUnnamed = isOSMUnnamed(properties);
    const featureType = properties?.type || properties?.class;
    const isPeak = properties?.class?.includes('summit') || properties?.type === 'peak';

    if (!isUnnamed) {
        return properties?.name ?? properties?.title;
    }
    if (isPeak) {
        const elevation = unitSystem === 'metric' ? properties?.ele_meters : properties?.ele_feet;
        // Elevation may be unavailable at lower zoom levels
        return elevation ? `Peak ${elevation}` : `Peak`;
    }
    if (featureType) {
        return `${capitalize(featureType.replace('_', ' '))}`;
    }
    return 'Unknown structure';
}
